import * as loglevel from 'loglevel';

// according to current enviroment to setup log level.
let appLogLevel = process.env.NODE_ENV !== 'production' ? loglevel.levels.DEBUG : loglevel.levels.INFO;
loglevel.setLevel(appLogLevel);
// loglevel.setLevel(loglevel.levels.INFO);


let appLogger = loglevel.noConflict().getLogger('app');

const style = {
  error: {
    'color': 'white',
    'background-color': '#FF5252'
  },
  warn: {
    'color': 'white',
    'font-weight': 'blod',
    'background-color': '#FFC107',
  },
  info: {
    'color': 'white',
    'font-weight': 'blod',
    'background-color': '#2196F3'
  },
  debug: {
    'color': 'white',
    'font-weight': 'blod',
    'background-color': 'rgba(0,0,0,0.35)'
  },
  trace: {
    'color': 'black',
    'font-weight': 'blod'
  }
};

let customLogger = {
  _getMsgInfo(args) {
    // %c is a parameter for styling.
    // see https://developers.google.com/web/tools/chrome-devtools/console/console-write?hl=zh-tw
    let message = '%c';
    let params = [];

    let msgs = [];

    // compose tag message string
    if (this._tags) {
      this._tags.forEach(t => msgs.push(`[${t}]`));
    }

    // take first argument as a part of message string if it's type is "string"
    if (args.length > 0 && typeof args[0] === 'string') {
      msgs.push(args[0]);
      args.splice(0, 1);
    }

    for (let i = 0; i < args.length; i++) {
      params.push(args[i]);
    }

    message += msgs.join(' ');
    return {message, params};
  },

  _getStyle(level) {
    return Object.entries(style[level]).map(s => s.join(':')).join(';');
  },

  _log(level, args) {
    let msgInfo = this._getMsgInfo(args);
    let style = this._getStyle(level);
    appLogger[level](msgInfo.message, style, ...msgInfo.params);
  },

  tag(...tags) {
    return Object.assign({}, {_tags: tags}, this);
  },

  error(...args) {
    this._log('error', args);
  },

  warn(...args) {
    this._log('warn', args);
  },

  info(...args) {
    this._log('info', args);
  },

  debug(...args) {
    this._log('debug', args);
  },

  trace(...args) {
    this._log('trace', args);
  }
}


// let loglevel module can be accessed in console.
window._loglevel = loglevel;

// let our custom logger can be accessed globally without import.
window.log = customLogger;